import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { lieu, nombre, nomSource, nomVoiture, vueDepuis } from './format';
import { VerdictCompact } from './VerdictPrix';

/**
 * Une bonne affaire (maquette validée le 2026-09-14).
 *
 * Hiérarchie : photo, modèle, PRIX en gros, cote barrée, écart en vert dans une
 * tuile. Le prix ancre, l'écart qualifie. Une photo qui ne charge pas garde sa
 * place et le dit : ~40 % du stock n'a plus de photo servable, et ce sont
 * souvent les meilleures affaires (cf. mémoire photos_mortes_par_source).
 *
 * Lien fermé (visiteur) : la carte le dit sans mot de paiement et propose le
 * compte gratuit, avec retour sur l'annonce. Lien ouvert (compte connecté) :
 * le site d'origine et le dernier passage (2026-10-22).
 */
export default function AffaireCard({ a }) {
  const [photoKo, setPhotoKo] = useState(false);
  const photo = a.photo && !photoKo;
  const ou = lieu(a);
  const navigate = useNavigate();
  const fiche = `/listings/${a.id}`;

  /* La carte entière est un lien vers la fiche ; ce raccourci va droit à
     l'inscription, qui ramène ensuite sur la fiche. */
  function creerCompte(e) {
    e.preventDefault();
    navigate(`/register?suivant=${encodeURIComponent(fiche)}`);
  }

  return (
    <Link to={fiche} className="zk-aff-carte">
      <div className={`zk-aff-photo${photo ? '' : ' vide'}`}>
        {photo ? (
          <img src={a.photo} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setPhotoKo(true)} />
        ) : (
          <span>Photo indisponible</span>
        )}
        {a.ecart_pct != null && <span className="zk-aff-pct">−{Math.round(a.ecart_pct)} %</span>}
      </div>
      <div className="zk-aff-corps">
        <h3 className="zk-aff-nom">{nomVoiture(a)}</h3>
        <p className="zk-aff-specs">
          {[a.annee, a.km != null ? `${nombre(a.km)} km` : null, a.energie].filter(Boolean).join(' · ')}
        </p>
        <p className="zk-aff-prix">{nombre(a.prix)} €</p>
        {a.cote != null && (
          <p className="zk-aff-cote">cote <s>{nombre(a.cote)} €</s></p>
        )}
        <VerdictCompact v={a.niveau_prix || { niveau: a.niveau || (a.ecart_eur != null ? 'SOLIDE' : null), ecart_eur: a.ecart_eur }} />
        <p className="zk-aff-meta">
          <span>{ou}</span>
          <span>{vueDepuis(a.vue_depuis_jours)}</span>
        </p>
        {a.verrouille && (
          <span className="zk-aff-compte" onClick={creerCompte}>
            Créer un compte gratuit pour voir l’annonce
          </span>
        )}
        {!a.verrouille && a.source && (
          <p className="zk-aff-source">
            Sur {nomSource(a.source)}
            {a.observee_il_y_a_jours != null && ` · vue ${a.observee_il_y_a_jours === 0 ? 'aujourd’hui' : `il y a ${a.observee_il_y_a_jours} j`}`}
          </p>
        )}
      </div>
    </Link>
  );
}
